module.exports = __webpack_public_path__ + "img/组 1121@2x.4ce8f263.png";